import {locale as proposals_en} from "./en/locale.proposals-decline";
import {locale as proposals_ru} from "./ru/locale.proposals-decline";

export const proposals_decline_dialog = [
  {
    lang: 'en',
    data: proposals_en
  },
  {
    lang: 'ru',
    data: proposals_ru
  },
];

